import { mapState } from "vuex";

export default {
    computed: {
        ...mapState("components", ["properties", "components", "bodyReference"])
    },
    methods: {
        __isInNamespace(startParent) {
            let config; let properties; let found = false; let
                parent = startParent;
            while (!found && parent) {
                properties = this.properties[parent];
                config = this.components[properties.__component];
                if (config.namespace) {
                    found = true;
                } else {
                    parent = properties.parent;
                }
            }
            return found;
        },
        __componentIsInNamespace(guid) {
            let found = false;

            if (guid) {
                let config; let properties = this.properties[guid]; let
                    { parent } = properties;
                while (!found && parent) {
                    properties = this.properties[parent];
                    config = this.components[properties.__component];
                    if (config.namespace) {
                        found = true;
                    } else {
                        parent = properties.parent;
                    }
                }
            }
            return found;
        },
        __firstNamespaceParent(guid) {
            let container = null;
            if (guid) {
                let config; let properties = this.properties[guid]; let
                    { parent } = properties;
                while (!container && parent) {
                    properties = this.properties[parent];
                    config = this.components[properties.__component];
                    if (config.namespace) {
                        container = parent;
                    } else {
                        parent = properties.parent;
                    }
                }
            }

            return container;
        },
        __resetComponentModel(guid, modelState) {
            const { get = false, set = false, values = false } = modelState;
            let recursive = false;
            const properties = this.properties[guid];
            const config = this.components[properties.__component];

            if (get && config.get) { recursive = true; properties.get = null; }
            if (set && config.set) { recursive = true; properties.set = null; }
            if (values && config.values) { properties.values = null; }

            if (recursive && this.bodyReference.hasOwnProperty(guid)) {
                this.bodyReference[guid].forEach(component => {
                    this.__resetComponentModel(component.guid, modelState);
                });
            }
        }
        // , __getAllParents(guid) {
        //
        // },
        // __getAllChildrens() {
        //
        // },
        // __getAllChildrensOfType() {
        //
        // },
        // __getAllChildrentContainers() {
        //
        // }
    }
};
